"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var Off = function Off() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.8405 19.7202C2.44998 20.1107 2.44998 20.7439 2.8405 21.1344C3.23102 21.5249 3.86419 21.5249 4.25471 21.1344L12.0004 13.3887L19.7461 21.1344C20.1366 21.5249 20.7698 21.5249 21.1603 21.1344C21.5508 20.7439 21.5508 20.1107 21.1603 19.7202L13.4146 11.9745L21.1094 4.27974C21.4999 3.88921 21.4999 3.25605 21.1094 2.86552C20.7189 2.475 20.0857 2.475 19.6952 2.86552L12.0004 10.5603L4.30565 2.86553C3.91512 2.475 3.28196 2.475 2.89143 2.86553C2.50091 3.25605 2.50091 3.88921 2.89143 4.27974L10.5862 11.9745L2.8405 19.7202Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5"
    })
  });
};
var _default = Off;
exports["default"] = _default;